
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/blog",
      function () {
        return require("private-next-pages/news/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/blog"])
      });
    }
  